const gridView = document.querySelectorAll('.grid-view span');
if (gridView) {
  gridView.forEach((el) => {
    el.addEventListener('click', () => {
      gridView.forEach((el) => el.classList.remove('active'));
      el.classList.add('active');
      document.querySelector('#product-grid').dataset.view = el.dataset.gridView;
    });
  });
}
